var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Mobile/components/SolutionByNeed.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { List } from '@wds/list';
import { Typography } from '@wds/typography';
export var SolutionByNeed = function SolutionByNeed(_ref) {
  var title = _ref.title,
    url = _ref.url,
    openInNewWindow = _ref.openInNewWindow;
  return /*#__PURE__*/React.createElement(List.Item, Object.assign({
    key: title,
    isNavigable: true,
    navigationTarget: url
  }, openInNewWindow === true && {
    target: '_blank',
    rel: 'noopener noreferrer'
  }, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Box, {
    my: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "link",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }, title)));
};
export default SolutionByNeed;
SolutionByNeed.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  openInNewWindow: PropTypes.bool
};
SolutionByNeed.defaultProps = {
  openInNewWindow: false
};
//# sourceMappingURL=SolutionByNeed.js.map